import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Search from 'pages/parts/Search';
import Pagination from 'pages/parts/Pagination';
import TariffModal from './TariffModal';

import { GET, PGET } from 'helpers/api';
import { formatDate, formatMoney, checkRole } from 'helpers/helpers';

function Index() {
	const URL = '/services/web/api/pos-pageList';
	const { t } = useTranslation();
	const settings = useSelector(state => state.settings);
	const canUpdate = checkRole('POS_SETTINGS_POS_EDIT');

	const [pageCount, setPageCount] = useState(0);
	const [data, setData] = useState([]);
	const [selectedItem, setSelectedItem] = useState(null);

	useEffect(() => {
		getData();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	async function getData() {
		const response = await PGET(URL, {}, { loader: true });
		if (response) {
			setPageCount(Math.ceil(response.headers['x-total-count'] / settings.size));
			setData(response.data);
		}
	}

	async function paginate(data) {
		const response = await PGET(URL, { page: data.selected, size: settings.size }, { loader: true });
		setData(response.data);
	}

	async function search(data, searchValue) {
		setData(data);
		if (searchValue.length > 0) setPageCount(0);
	}

	const getTariffName = (id) => {
		switch (Number(id)) {
			case 1: return 'Start';
			case 2: return 'Standart';
			case 3: return 'Premium';
			default: return 'Nomaʼlum';
		}
	};


	const getTariffIcon = (id) => {
		switch (Number(id)) {
			case 1: return 'uil-rocket';        // Start
			case 2: return 'uil-layer-group';   // Standart
			case 3: return 'uil-diamond';       // Premium
			default: return 'uil-tag';
		}
	};

	const getTariffClass = (id) => {
		switch (Number(id)) {
			case 1:
				return 'bg-gradient-to-r from-blue-300 to-blue-600  shadow-md text-sm px-3 py-1 rounded-pill border border-primary';
			case 2:
				return 'bg-gradient-to-r from-cyan-300 to-teal-500  shadow-md text-sm px-3 py-1 rounded-pill border border-info';
			case 3:
				return 'bg-gradient-to-r from-orange-300 via-yellow-400 to-yellow-600 text-black shadow-sm text-base fw-bold px-4 py-2 rounded-pill border border-warning';
			default:
				return 'bg-dark text-white px-3 py-1 rounded-pill';
		}
	};



	return (
		<>
			<div className="page-header d-flex mb-2">
				<h4 className="vertical-center">{t('POSES')}</h4>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex mb-3">
						<div className="me-2">
							<Search url={URL} search={search} getData={getData} />
						</div>
					</div>

					<div className="table-responsive">
						<table className="table table-striped mb-0">
							<thead>
								<tr>
									<th>{t('ID')}</th>
									<th>{t('BILLING_ID')}</th>
									<th>{t('IMAGE2')}</th>
									<th>{t('SALE_POINT_NAME')}</th>
									<th className="text-center">{t('DATE_OF_CREATION')}</th>
									<th className="text-center text-nowrap">{t('TARIF')}</th>
									<th className="text-center">{t('ACTIVE_UNTIL')}</th>
									<th className="text-center">{t('ACTIVATED')}</th>
									<th className="text-center">{t('MSG_BALANCE')}</th>
									<th className="text-center">{t('BALANCE')}</th>
									<th className="text-center">{t('ACTION')}</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr className="tr-middle" key={index}>
										<td>{item.id}</td>
										<td><b>I-{item.id}</b></td>
										<td>
											{item.imageUrl ? (
												<img src={process.env.REACT_APP_PROD_SERVER_URL + item.imageUrl} alt="react" width="50" height="50" />
											) : (
												<div className="table-no-image">
													<i className="uil uil-camera position-relative fz-20" style={{ top: '20%' }}></i>
												</div>
											)}
										</td>
										<td>{item.name}</td>
										<td className="text-center">{formatDate(item.createdDate)}</td>
										<td className="text-center" style={{ cursor: 'pointer' }}>
											<span
												className={`d-inline-flex align-items-center gap-2 cursor-pointer ${getTariffClass(item.tariffId)} hover-scale`}
												title="Tarifni o‘zgartirish"
												onClick={() => setSelectedItem(item)}
											>
												<i className={`uil ${getTariffIcon(item.tariffId)} fz-16`}></i>
												{getTariffName(item.tariffId)}
											</span>
										</td>

										<td className="text-center">
											{item.activated ? (
												<span className="bg-primary bg-border text-white">{formatDate(item.activeUntil)}</span>
											) : ""}
										</td>
										<td className="text-center">
											{item.activated ? (
												<span className="bg-primary bg-border text-white">{t('YES')}</span>
											) : (
												<span className="bg-danger bg-border text-white">{t('NO')}</span>
											)}
										</td>
										<td className="text-center">{item.msgCount}</td>
										<td className="text-center">{formatMoney(item.balance)}</td>
										<td>
											<div className="d-flex justify-content-center">
												{canUpdate && (
													<Link className="table-action-button table-action-primary-button" to={`/pos-update/${item.id}`}>
														<i className="uil-edit-alt"></i>
													</Link>
												)}
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					<Pagination pageCount={pageCount} paginate={paginate} />
				</div>
			</div>

			{selectedItem && (
				<TariffModal
					item={selectedItem}
					onClose={() => setSelectedItem(null)}
					onSave={() => {
						setSelectedItem(null);
						getData();
					}}
					onPaymentRequired={({ posId, amountNeeded }) => {
						window.dispatchEvent(new CustomEvent('open-billing-payment', { detail: { posId, amountNeeded } }));
					}}
				/>
			)}

		</>
	);
}

export default Index;
